export const ROOT_CHANGED = 'ROOT_CHANGED';
export const OPEN_NOTIFICATION = 'OPEN_NOTIFICATION';
export const LANGUAGE_CHANGED = 'LANGUAGE_CHANGED';
export const CARD_CHANGED = 'CARD_CHANGED';
export const SET_USER = 'SET_USER';
export const LOGOUT = 'LOGOUT';
export const PROVIDER_SEARCH = 'PROVIDER_SEARCH';
export const TIME_TRACKER = 'TIME_TRACKER';
export const MESSAGE_ADMIN = 'MESSAGE_ADMIN';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const FILE_UPLOAD_LINK = 'FILE_UPLOAD_LINK';
export const DOUBLE_ARROW_RIGHT_LINK = 'DOUBLE_ARROW_RIGHT_LINK';
export const DOUBLE_ARROW_RIGHT01_LINK = 'DOUBLE_ARROW_RIGHT01_LINK';
export const BACK_LINK = 'BACK_LINK';
export const CLEAR_SEARCH_PROVIDER = 'CLEAR_SEARCH_PROVIDER';
export const ACCESSIBILITY_LABEL_MASSACHUSETTS_CARD_FRONT = 'accLblMassachusettsCardFront';
export const ACCESSIBILITY_LABEL_MASSACHUSETTS_CARD_BACK = 'accLblMassachusettsCardBack';
export const ADD_CHAT_DATA = 'ADD_CHAT_DATA';

export const LOAD_PIN = 'LOAD_PIN';
export const LOAD_PIN_SUCCESS = 'LOAD_PIN_SUCCESS';
export const LOAD_PIN_FAIL = 'LOAD_PIN_FAIL';

export const GET_FILE = 'GET_FILE';
export const GET_FILE_SUCCESS = 'GET_FILE_SUCCESS';
export const GET_FILE_FAIL = 'GET_FILE_FAIL';

export const CHANGE_ALERT_STATUS = 'CHANGE_ALERT_STATUS';
export const CHANGE_ALERT_STATUS_SUCCESS = 'CHANGE_ALERT_STATUS_SUCCESS';
export const CHANGE_ALERT_STATUS_FAIL = 'CHANGE_ALERT_STATUS_FAIL';

export const CHANGE_BROADCAST_STATUS = 'CHANGE_BROADCAST_STATUS';
export const CHANGE_BROADCAST_FAIL = 'CHANGE_BROADCAST_FAIL';

export const CHANGE_BROADCAST_ALERT_STATUS = 'CHANGE_BROADCAST_ALERT_STATUS';

export const OTP_STATUS_MOBILE = 'OTP_STATUS_MOBILE';
export const OTP_STATUS_MOBILE_SUCCESS = 'OTP_STATUS_MOBILE_SUCCESS';
export const OTP_STATUS_MOBILE_FAIL = 'OTP_STATUS_MOBILE_FAIL';
export const OTP_STATUS_EMAIL = 'OTP_STATUS_EMAIL';
export const OTP_STATUS_EMAIL_SUCCESS = 'OTP_STATUS_EMAIL_SUCCESS';
export const OTP_STATUS_EMAIL_FAIL = 'OTP_STATUS_EMAIL_FAIL';
export const OTP_STATUS_EMAIL_CLEAR = 'OTP_STATUS_EMAIL_CLEAR';

export const SAVE_OTP = 'SAVE_OTP';
export const SAVE_OTP_SUCCESS = 'SAVE_OTP_SUCCESS';
export const SAVE_OTP_FAIL = 'SAVE_OTP_FAIL';

export const SAVE_MFA = 'SAVE_MFA';
export const SAVE_MFA_SUCCESS = 'SAVE_MFA_SUCCESS';
export const SAVE_MFA_FAIL = 'SAVE_MFA_FAIL';

export const TRIGGER_MFA = 'TRIGGER_MFA';
export const TRIGGER_MFA_SUCCESS = 'TRIGGER_MFA_SUCCESS';
export const TRIGGER_MFA_FAIL = 'TRIGGER_MFA_FAIL';
export const TRIGGER_MFA_CLEAR = 'TRIGGER_MFA_CLEAR';

export const LOAD_GET_MEMBER_MFA = 'MEMBER_MFA';
export const LOAD_GET_MEMBER_MFA_SUCCESS = 'MEMBER_MFA_SUCCESS';
export const LOAD_GET_MEMBER_MFA_FAIL = 'MEMBER_MFA_FAIL';

export const UNSYNC_ALERTS = 'UNSYNC_ALERTS';
export const SYNC_ALERTS = 'SYNC_ALERT';

export const LOAD_ALERTS = 'LOAD_ALERTS';
export const LOAD_ALERTS_SUCCESS = 'LOAD_ALERTS_SUCCESS';
export const LOAD_ALERTS_FAIL = 'LOAD_ALERTS_FAIL';

export const LOAD_ADD_BUSINESS = 'LOAD_ADD_BUSINESS';
export const LOAD_ADD_BUSINESS_SUCCESS = 'LOAD_ADD_BUSINESS_SUCCESS';
export const LOAD_ADD_BUSINESS_FAIL = 'LOAD_ADD_BUSINESS_FAIL';

export const LOAD_GET_BUSINESS = 'LOAD_GET_BUSINESS';
export const LOAD_GET_BUSINESS_SUCCESS = 'LOAD_GET_BUSINESS_SUCCESS';
export const LOAD_GET_BUSINESS_FAIL = 'LOAD_GET_BUSINESS_FAIL';

export const LOAD_SAVE_ENTRIES = 'LOAD_SAVE_ENTRIES';
export const LOAD_SAVE_ENTRIES_SUCCESS = 'LOAD_SAVE_ENTRIES_SUCCESS';
export const LOAD_SAVE_ENTRIES_FAIL = 'LOAD_SAVE_ENTRIES_FAIL';

export const LOAD_GET_ENTRIES = 'LOAD_GET_ENTRIES';
export const LOAD_GET_ENTRIES_SUCCESS = 'LOAD_GET_ENTRIES_SUCCESS';
export const LOAD_GET_ENTRIES_FAIL = 'LOAD_GET_ENTRIES_FAIL';

export const LOAD_GET_SUMMARY = 'LOAD_GET_SUMMARY';
export const LOAD_GET_SUMMARY_SUCCESS = 'LOAD_GET_SUMMARY_SUCCESS';
export const LOAD_GET_SUMMARY_FAIL = 'LOAD_GET_SUMMARY_FAIL';
export const CLEAR_SUMMARY_DATA = 'CLEAR_SUMMARY_DATA';

export const LOAD_OPT_OUT = 'LOAD_OPT_OUT';
export const LOAD_OPT_OUT_SUCCESS = 'LOAD_OPT_OUT_SUCCESS';
export const LOAD_OPT_OUT_FAIL = 'LOAD_OPT_OUT_FAIL';
export const CLEAR_OPT_OUT_ERROR = 'CLEAR_OPT_OUT_ERROR';
export const CLEAR_OPT_OUT = 'CLEAR_OPT_OUT';

export const LOAD_BROADCAST = 'LOAD_BROADCAST';
export const LOAD_BROADCAST_SUCCESS = 'LOAD_BROADCAST_SUCCESS';
export const LOAD_BROADCAST_FAIL = 'LOAD_BROADCAST_FAIL';

export const RESET = 'RESET';
export const RESET_CHECK_USER = 'RESET_CHECK_USER';

export const LOAD_DIGITAL_CARD = 'LOAD_DIGITAL_CARD';
export const LOAD_DIGITAL_CARD_SUCCESS = 'LOAD_DIGITAL_CARD_SUCCESS';
export const LOAD_DIGITAL_CARD_FAIL = 'LOAD_DIGITAL_CARD_FAIL';

export const MY_HEALTH_SUMMARY = 'MY_HEALTH_SUMMARY';
export const MY_HEALTH_SUMMARY_SUCCESS = 'MY_HEALTH_SUMMARY_SUCCESS';
export const MY_HEALTH_SUMMARY_FAIL = 'MY_HEALTH_SUMMARY_FAIL';
export const LABEL_HEALTH_SUMMARY = 'hdrHealthSummary';

export const LOAD_MEMBER_RESOURCE = 'LOAD_MEMBER_RESOURCE';
export const LOAD_MEMBER_RESOURCE_SUCCESS = 'LOAD_MEMBER_RESOURCE_SUCCESS';
export const LOAD_MEMBER_RESOURCE_FAIL = 'LOAD_MEMBER_RESOURCE_FAIL';

export const SET_PIN = 'SET_PIN';
export const SET_PIN_SUCCESS = 'SET_PIN_SUCCESS';
export const SET_PIN_FAIL = 'SET_PIN_FAIL';
export const SET_FAILED_COUNT = 'SET_FAILED_COUNT';

export const PIN = 'PIN';
export const LOGIN = 'LOGIN';
export const MAIN = 'MAIN';
export const REGISTER = 'REGISTER';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const HOME_REQUEST = 'HOME_REQUEST';
export const HOME_SUCCESS = 'HOME_SUCCESS';
export const HOME_FAIL = 'HOME_FAIL';

export const TERMSERVICE_REQUEST = 'TERMSERVICE_REQUEST';
export const TERMSERVICE_SUCCESS = 'TERMSERVICE_SUCCESS';
export const TERMSERVICE_FAIL = 'TERMSERVICE_FAIL';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAIL = 'REFRESH_TOKEN_FAIL';

export const CHECK_USER_EXIST_REQUEST = 'CHECK_USER_EXIST_REQUEST';
export const CHECK_USER_EXIST_SUCCESS = 'CHECK_USER_EXIST_SUCCESS';
export const CHECK_USER_EXIST_FAIL = 'CHECK_USER_EXIST_FAIL';

export const SUPPORT_BOT_REQUEST = 'SUPPORT_BOT_REQUEST';
export const SUPPORT_BOT_SUCCESS = 'SUPPORT_BOT_SUCCESS';
export const SUPPORT_BOT_FAIL = 'SUPPORT_BOT_FAIL';

export const SHARE_CARD_OTP_REQUEST = 'SHARE_CARD_OTP_REQUEST';
export const SHARE_CARD_OTP_SUCCESS = 'SHARE_CARD_OTP_SUCCESS';
export const SHARE_CARD_OTP_FAIL = 'SHARE_CARD_OTP_FAIL';

export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL';

export const PROVIDER_LOGIN_REQUEST = 'PROVIDER_LOGIN_REQUEST';
export const PROVIDER_LOGIN_SUCCESS = 'PROVIDER_LOGIN_SUCCESS';
export const PROVIDER_LOGIN_FAIL = 'PROVIDER_LOGIN_FAIL';

export const PROVIDER_SEARCH_REQUEST = 'PROVIDER_SEARCH_REQUEST';
export const PROVIDER_SEARCH_LOADING_DISTANCE = 'PROVIDER_SEARCH_LOADING_DISTANCE';
export const PROVIDER_SEARCH_LOADING_SPECIALTY = 'PROVIDER_SEARCH_LOADING_SPECIALTY';
export const PROVIDER_SEARCH_LOADING_PROVIDER_TYPE = 'PROVIDER_SEARCH_LOADING_PROVIDER_TYPE';
export const PROVIDER_SEARCH_LOADING_SEARCH_PROVIDER = 'PROVIDER_SEARCH_LOADING_SEARCH_PROVIDER';
export const PROVIDER_SEARCH_SUCCESS_SEARCH_PROVIDER = 'PROVIDER_SEARCH_SUCCESS_SEARCH_PROVIDER';
export const PROVIDER_SEARCH_SUCCESS_DISTANCE = 'PROVIDER_SEARCH_SUCCESS_DISTANCE';
export const PROVIDER_SEARCH_SUCCESS_SPECIALTY = 'PROVIDER_SEARCH_SUCCESS_SPECIALTY';
export const PROVIDER_SEARCH_SUCCESS_PROVIDER_TYPE = 'PROVIDER_SEARCH_SUCCESS_PROVIDER_TYPE';
export const PROVIDER_SEARCH_SELECT_PCP_LINK = 'PROVIDER_SEARCH_SELECT_PCP_LINK';
export const PROVIDER_SEARCH_SELECTED_PCP_LINK = 'PROVIDER_SEARCH_SELECTED_PCP_LINK';

export const LOAD_PCP_DETAILS = 'LOAD_PCP_DETAILS';
export const LOAD_GET_PCP_DETAILS_SUCCESS = 'LOAD_GET_PCP_DETAILS_SUCCESS';
export const LOAD_GET_PCP_ENTRIES_FAIL = 'LOAD_GET_PCP_ENTRIES_FAIL';

export const DELETE_PCP_DETAILS = 'DELETE_PCP_DETAILS';
export const DELETE_GET_PCP_DETAILS_SUCCESS = 'DELETE_GET_PCP_DETAILS_SUCCESS';
export const DELETE_GET_PCP_ENTRIES_FAIL = 'DELETE_GET_PCP_ENTRIES_FAIL';

export const PROVIDER_SEARCH_SAVE_PCP = 'PROVIDER_SEARCH_SAVE_PCP';
export const PROVIDER_SEARCH_DELETE_PCP = 'PROVIDER_SEARCH_DELETE_PCP';
export const PROVIDER_SEARCH_SAVE_PCP_ENTRIES = 'PROVIDER_SEARCH_SAVE_PCP_ENTRIES';
export const PROVIDER_SEARCH_SAVE_PCP_ENTRIES_FAIL = 'PROVIDER_SEARCH_SAVE_PCP_ENTRIES_FAIL';
export const PROVIDER_SEARCH_SAVE_PCP_ENTRIES_SUCCESS = 'PROVIDER_SEARCH_SAVE_PCP_ENTRIES_SUCCESS';

export const PROVIDER_SEARCH_FAIL_DISTANCE = 'PROVIDER_SEARCH_FAIL_DISTANCE';
export const PROVIDER_SEARCH_FAIL_SPECIALTY = 'PROVIDER_SEARCH_FAIL_SPECIALTY';
export const PROVIDER_SEARCH_FAIL_PROVIDER_TYPE = 'PROVIDER_SEARCH_FAIL_PROVIDER_TYPE';
export const PROVIDER_SEARCH_FAIL_SEARCH_PROVIDER = 'PROVIDER_SEARCH_FAIL_SEARCH_PROVIDER';
export const SAVE_FLAG_SEARCH_PROVIDER = 'SAVE_FLAG_SEARCH_PROVIDER';
export const UN_SAVE_FLAG_SEARCH_PROVIDER = 'UN_SAVE_FLAG_SEARCH_PROVIDER';
export const DELETE_FILE_SEARCH_PROVIDER = 'DELETE_FILE_SEARCH_PROVIDER';

export const REMOVE_SAVED_CARD = 'REMOVE_SAVED_CARD';

export const SAVE_FILE = 'SAVE_FILE';
export const DELETE_FILE = 'DELETE_FILE';
export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAIL = 'UPLOAD_FILE_FAIL';
export const CLEAR_ALL_FILES = 'CLEAR_ALL_FILES';
export const CLEAR_SUCCESSFULLY_UPLOADED_FILES = 'CLEAR_SUCCESSFULLY_UPLOADED_FILES';

export const SAVE_FILE_TIME_TRACKER = 'SAVE_FILE_TIME_TRACKER';
export const DELETE_FILE_TIME_TRACKER = 'DELETE_FILE_TIME_TRACKER';
export const UPLOAD_FILE_REQUEST_TIME_TRACKER = 'UPLOAD_FILE_REQUEST_TIME_TRACKER';
export const UPLOAD_FILE_SUCCESS_TIME_TRACKER = 'UPLOAD_FILE_SUCCESS_TIME_TRACKER';
export const UPLOAD_FILE_FAIL_TIME_TRACKER = 'UPLOAD_FILE_FAIL_TIME_TRACKER';
export const CLEAR_ALL_FILES_TIME_TRACKER = 'CLEAR_ALL_FILES_TIME_TRACKER';
export const CLEAR_SUCCESSFULLY_UPLOADED_FILES_TIME_TRACKER =
  'CLEAR_SUCCESSFULLY_UPLOADED_FILES_TIME_TRACKER';

export const LOAD_SAVE_ADDRESS = 'LOAD_SAVE_ADRESS';
export const LOAD_SAVE_ADDRESS_SUCCESS = 'LOAD_SAVE_ADRESS_SUCCESS';
export const LOAD_SAVE_ADDRESS_FAIL = 'LOAD_SAVE_ADRESS_FAIL';

export const LOAD_GET_ADDRESS = 'LOAD_GET_ADDRESS';
export const LOAD_GET_ADDRESS_SUCCESS = 'LOAD_GET_ADDRESS_SUCCESS';
export const LOAD_GET_ADDRESS_FAIL = 'LOAD_GET_ADDRESS_FAIL';

export const LOAD_REMOVE_ADDRESS = 'LOAD_REMOVE_ADDRESS';
export const LOAD_REMOVE_ADDRESS_SUCCESS = 'LOAD_REMOVE_ADDRESS_SUCCESS';
export const LOAD_REMOVE_ADDRESS_FAIL = 'LOAD_REMOVE_ADDRESS_FAIL';

/* constant for common uses */
export const POST = 'post';
export const GET = 'get';
export const MON = 'Mon';
export const TUE = 'Tue';
export const WED = 'Wed';
export const THU = 'Thu';
export const FRI = 'Fri';
export const SAT = 'Sat';
export const SUN = 'Sun';
export const MESSAGE_SEND = 'S';
export const MESSAGE_READ = 'R';
export const YES = 'Y';
export const NO = 'N';
export const YES_1 = 'Yes';
export const NO_1 = 'No';
export const COMMA = ',';
export const SLASH = '/';
export const CAMERA = 'CAMERA';
export const GALLERY = 'GALLERY';
export const PDF = 'PDF';
export const ANDROID = 'android';
export const IOS = 'ios';
export const THREE_DOT = '...';
export const PNG = 'png';
export const JPEG = 'jpeg';
export const JPG = 'jpg';
export const PDF_LOWER = 'pdf';
export const BASE_64 = 'data:image/jpg;base64';
export const IMAGE_JPEG = 'image/jpeg';
export const IMAGE_JPG = 'image/jpg';
export const IMAGE_PNG = 'image/png';
export const APPLICATION_PDF = 'application/pdf';
export const BASE64 = 'base64';
export const APP_SETTINGS = 'app-settings:';
export const SECONDS = 'seconds';
export const FILE_SIZE = '<FILE_SIZE>';
export const FILE_LIMIT = '<FILE_LIMIT>';
export const COUNT = '<count>';
export const SUCCESS_CODE = 200;
export const API_LEVEL = 23;
export const QUALITY = 1;
export const IMAGE_SIZE = 1000;
export const MINUS_ONE = -1;
export const ZERO_DOT_SEVEN = 0.7;
export const ZERO = 0;
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
export const FOUR = 4;
export const FIVE = 5;
export const SIX = 6;
export const EIGHT = 8;
export const NINE = 9;
export const NINE_AND_HALF = 9.6;
export const TWENTY = 20;
export const TWENTY_TWO = 22;
export const TWENTY_FOUR = 24;
export const TWENTY_FIVE = 25;
export const THIRTY_TWO = 32;
export const FIFTEN = 15;
export const SIXTEEN = 16;
export const EIGHTEEN = 18;
export const TWELVE = 12;
export const TWENTY_SIX = 26;
export const THIRTY = 30;
export const FIFTY = 50;
export const THREE_FOURTH = 0.75;
export const FOURTY = 40;
export const TIME_OUT_500 = 500;
export const FIRST_NAME = '<first name>';
export const EXPIRE_IN_30_SEC = 30;
export const SCREEN_OFF = 5000;
export const TEN = 10;
export const ONE_FIFTY = 150;
export const THOUSAND = 1000;
export const CODE_LENGTH = 4;
export const SHARE_CARD = 'ShareCard';
export const MONTHS = 'months';
export const TIME_TRACKER_SUMMARY = 'TimeTrackerSummary';
export const CALENDAR = 'Calendar';
export const TIME_TRACKER_COUNT = '<count>';
export const HOURS = 'hours';
export const OPT_OUT_PREFERENCE = 'R';
export const OPT_OUT_PREFERENCE_VALUE = 'O';
export const SESSION_TIME_OUT = 'sessionTimeOut';
export const UPLOAD_FLAG = 'UPLOAD';
export const TIME_TRACKER_FLAG = 'TIME_TRACKER';
export const HASH_SYMBOL = '#';
export const TWO_TWENTY_FIVE = '225';

/* DIGITAL_CARD_TYPES */
export const DIGITAL_CARD_MASS_HEALTH = 'massHealth';
export const DIGITAL_CARD_OKLAHOMA = 'oklahoma';
export const DIGITAL_CARD_SOONER_CARE = 'SoonerCare';
export const DIGITAL_CARD_TEXAS_BENEFITS = 'TexasBenefits';
export const DIGITAL_CARD_RI_HEALTH = 'RIHealth';
export const DIGITAL_CARD_WISCONSIN = 'Wisconsin';
export const DIGITAL_CARD_IDAHO = 'Idaho';
export const DIGITAL_CARD_LOUISIANA = 'Louisiana';
export const DIGITAL_CARD_ARKANSAS_KIDS = 'ArkansasKids';
export const DIGITAL_CARD_ARKANSAS_ADULT = 'ArkansasAdults';
export const DIGITAL_CARD_NEVADA = 'Nevada';
export const DIGITAL_CARD_AR_CARD_TEMPLATE = 'ARCardTemplate'; // AR client required this Template
export const DIGITAL_CARD_DENTICAL = 'California';
export const DIGITAL_CARD_DELAWARE = 'Delaware';

/* LINK FOR ICON, DRAWER AND  NAVIGATION */
export const LOGIN_LINK = 'Login';
export const LOGOUT_LINK = 'Logout';
export const HOME_LINK = 'Home';
export const UPLOAD_FILE_LINK = 'UploadFile';
export const REGISTER_ONE_LINK = 'RegisterOne';
export const REGISTER_SECOND_LINK = 'RegisterSecond';
export const TIME_TRACKER_LINK = 'TimeTracker';
export const TERMS_SERVICE_LINK = 'TermsService';
export const MY_BENEFITS_LINK = 'MyBenefits';
export const MEMBER_RESOURCE_LINK = 'MemberResource';
export const MFA_VERIFY_LINK = 'MFALogin';
export const MFA_SETUP_LINK = 'MFASetup';
export const MFA_STOP_LINK = 'MFAStopLink';
export const MESSAGES_LINK = 'Messages';
export const DIGITAL_CARD_LINK = 'DigitalCard';
export const MY_HEALTH_LINK = 'MyHealth';
export const MY_HEALTH_SUMMARY_LINK = 'MyHealthSummary';
export const FORMULARY_LINK = 'Formulary';
export const CHECKED = 'Checked';
export const UNCHECKED = 'UnChecked';
export const FORMULARY_SEARCH_RESULT_LINK = 'FormularySearchResults';
export const NEED_HELP_LINK = 'NeedHelp';
export const PROFILE_SETTING_LINK = 'ProfSetting';
export const MESSAGE_PREVIEW_LINK = 'MessagePreview';
export const REMINDER_LINK = 'Reminder';
export const ALARM_LINK = 'Alarm';
export const RADIO_CHECK = 'radio_button_checked';
export const RADIO_UN_CHECK = 'radio_button_unchecked';
export const MESSAGE_NEW_LINK = 'MessageNew';
export const MESSAGE_READ_LINK = 'MessageRead';
export const PICT_AS_PDF_LINK = 'picture_as_pdf';
export const LINK_ICON = 'link';
export const PROVIDER_SEARCH_LINK = 'ProviderSearch';
export const PCP_DETAILS_LINK = 'PcpDetails';
export const SEND_TO_AGENCY_LINK = 'SendToAgency';
export const LANGUAGE_LINK = 'Language';
export const OPT_OUT_LINK = 'OptOut';
export const PROVIDER_LOGIN_LINK = 'ProviderLogin';
export const PROVIDER_CARD_LINK = 'ProviderCard';
export const NOT_FOUND_PAGE_LINK = 'notFoundPage';
export const BROADCAST_READ_LINK = 'broadcast_read';
export const BROADCAST_UNREAD_LINK = 'broadcast_Unread';
export const BROADCAST_REJECTED_LINK = 'broadcast_rejected';
export const ADD_FAVORITE_LINK = 'AddFavorite';
export const REMOVE_FAVORITE_LINK = 'RemoveFavorite';
export const DIRECTION_LINK = 'direction';
export const FAVORITE_LINK = 'favorite';
export const PHONE_LINK = 'call';
export const DOUBLE_ARROW_LINK = 'doubleArrow';
export const KEYBOARD_ARROW_UP_LINK = 'keyboard_arrow_up';
export const KEYBOARD_ARROW_DOWN_LINK = 'keyboard_arrow_down';
export const MAIN_LINK = 'Main';
export const AUTH_LINK = 'Auth';
export const LOCATION_LINK = 'Location';
export const DONE_ALL_LINK = 'done_all';
export const CLOSE_LINK = 'close';
export const TRIANGLE_CLOSE_LINK = 'triangleClose';
export const CALENDAR_LINK = 'calendar';
export const MENU_LINK = 'menu';
export const SHARE_LINK = 'share';
export const SUMMARY_LINK = 'summary';
export const URI_LINK = 'uri';
export const PDF_LINK = 'PDFPage';
export const FAVORITE_RESULTS_LINK = 'FavoriteResultsScreen';
export const PIN_LINK = 'Pin';
export const SELECT_CARD_LINK = 'SelectCard';
export const ROTATE_CARD_LINK = 'RotateCard';
export const VISIBILITY_LINK = 'visibility';
export const VISIBILITY_OFF_LINK = 'visibility_off';
export const EDIT_ICON = 'edit_icon';
export const EDIT_ICON_1 = 'edit_icon1';
export const CROSS_ICON = 'cross_icon';
export const FEMALE_PIC = 'FemaleProfPic';
export const MALE_PIC = 'MaleProfPic';
export const FINGER_PRINT = 'fingerPrint';
export const AUTO_COMPLETE_OFF = 'off';
export const INPUT_PATTERN_NUMBER = '[0-9]*';
export const CHARACTER_ZERO = '0';
export const CHARACTER_NINE = '9';

/* REDUX FORM NAME INSIDE FILE */
export const USER_NAME = 'username';
export const USER_MOBILE_NUMBER = 'userMobileNo';
export const USER_MOBILE_EMAIL_VALIDATE = 'userMobileValidate';
export const USER_MOBILE_NUMBER_AUTHENTICATED = 'userMobileNoAuthenticated';
export const USER_EMAIL = 'userEmail';
export const REMEMBER_ME = 'remember_me';
export const PASSWORD = 'password';
export const REGISTER_PASSWORD = 'Password';
export const BUSINESS_NAME = 'BusinessName';
export const BUSINESS_ADDRESS = 'BusinessAddress';
export const BUSINESS_CITY = 'BusinessCity';
export const BUSINESS_STATE = 'BusinessState';
export const BUSINESS_ZIP = 'BusinessZip';
export const SIGN_IN_FORM = 'signIn';
export const ADDRESS_BUSINESS_FORM = 'AddBusinessForm';
export const BIRTH_DATE = 'BirthDate';
export const BIRTH_DATE_MM_DD_YYYY = 'MM/DD/YYYY';
export const DATE_SELECT_FORM = 'dateSelect';
export const FIRSTNAME = 'FirstName';
export const LASTNAME = 'LastName';
export const MEMBER_ID = 'MemberId';
export const SSN = 'SSN';
export const USERNAME = 'UserName';
export const CONFIRM_USER_NAME = 'ConfirmUserName';
export const CONFIRM_PASSWORD = 'ConfirmPassword';
export const REGISTER_FIRST_FORM = 'RegisterFirst';
export const REGISTER_SECOND_FORM = 'registerSecond';
export const TOTAL_HRS_WORKED = 'TotalHrsWorked';
export const EMPLOYER_NAME = 'EmployerName';
export const EMPLOYER_ADDRESS = 'EmployerAddress';
export const EMPLOYER_CITY = 'EmployerCity';
export const EMPLOYER_ZIP = 'EmployerZip';
export const TIME_TRACKER_FORM = 'TimeTrackerForm';
export const MEMBERS = 'members';
export const HOUR_INPUT_FORM = 'HourInputForm';
export const QUESTION = 'question';
export const QUESTION_FORM = 'QuestionForm';
export const EMAIL_ADDRESS = 'EmailAddress';
export const EMAIL_FORM = 'EmailForm';
export const ACCESS_CODE = 'AccessCode';
export const MESSAGES_ADMIN = 'messagesAdmin';
export const LOCATION = 'Location';
export const DISTANCE = 'Distance';
export const PROVIDER_TYPE = 'ProviderType';
export const SPECIALTY = 'Specialty';
export const PROVIDER_NAME = 'ProviderName';
export const PROVIDER_SEARCH_FORM = 'ProviderSearchForm';
export const DRUG_CLASS = 'DrugClass';
export const MEDICAL_CONDITION = 'MedicalConditions';
export const HEADER_FETCHED_INFO = 'hdrFetchedInfo';

/* LABEL */
export const LABEL_SHARED_OTP = 'lblSharedOTP';
export const LABEL_DISCARDED = 'lblDiscarded';
export const LABEL_HOUR_EXCEEDED = 'lblHourExceeded';
export const LABEL_VALID_HOURS = 'lblValidHours';
export const LABEL_TIME_TRACKER_SUCCESS_MSG = 'lblTimeTrackerSuccessMsg';
export const LABEL_PAGE_NOT_FOUND = 'lblPageNotFound';
export const LABEL_ERROR_INCORRECT_DOB = 'errIncorrectDOB';
export const LABEL_ERROR_VALID_DOB = 'errValidDOB';
export const LABEL_ERROR_INVALID_AUTH = 'errInvalidAuth';
export const LABEL_AUTH_CODE_SENT = 'lblAuthCodeSent';
export const LABEL_FORGOT_PASSWORD = 'lblLoginForPas';
export const LABEL_LOGIN_HEADING = 'hdrLoginHeading';
export const LABEL_PIN_MIS_MATCH = 'errValPinMisMat';
export const LABEL_PIN_MIS_MATCH_WARNING = 'errValPinMisMatWarning';
export const LABEL_EMPLOYER_ZIP = 'lblEmployerZip';
export const LABEL_EMPLOYER_CITY = 'lblEmployerCity';
export const LABEL_EMPLOYER_ADDRESS = 'lblEmployerAddress';
export const LABEL_EMPLOYER_ADDRESS_SECTION = 'lblEmployerAddressSection';
export const LABEL_EMPLOYER_NAME = 'lblEmployerName';
export const LABEL_TOTAL_HRS_WORKED = 'lblTotalHrsWorked';
export const LABEL_REGISTER_PASSWORD = 'lblRegisterPass';
export const LABEL_LOGIN_REMEMBER_ME = 'lblLoginRememberMe';
export const LABEL_SERVER_PAGE_NOT_FOUND = 'errServerPageNotFound';
export const LABEL_SERVER_NO_RECORD_FOUND = 'errServerNoRecordFound';
export const LABEL_BROWSER_NOT_SUPPORT = 'hdrBrowserNotSupport';
export const LABEL_PROVIDER_LOGIN = 'hdrProviderHeading';
export const LABEL_LOGIN = 'hdrLogin';
export const LABEL_PROVIDER_LOGIN_TITLE = 'hdrProviderLogin';
export const LABEL_TIME_TRACKER_SUMMARY = 'hdrTimeTrackerSummary';
export const LABEL_TIME_TRACKER_FILE_UPLOAD = 'hdrTimeTrackerFileUpload';
export const LABEL_TIME_TRACKER_FILE_UPLOAD_PARA = 'lblTimeTrackerFileUploadPara';
export const LABEL_TIME_TRACKER = 'hrdTimeTracker';
export const LABEL_TIMETRACKER_HEADER = 'lblTimeTrackerHeader';
export const LABEL_SELECT_DATE_RANGE = 'lblSelectDateRange';
export const LABEL_SELECT_BUSINESS = 'lblSelectBusiness';
export const LABEL_ADD_BUSINESS = 'lblBusinessAdd';
export const LABEL_MEMBER_RESOURCE = 'hdrMemberResource';
export const LABEL_NO_MEMBER_RESOURCE = 'lblNoMemRes';
export const LABEL_HOME = 'hdrHome';
export const LABEL_MY_BENEFITS = 'hdrMyBenefits';
export const LABEL_DIGITAL_CARD = 'hdrDigitalCard';
export const LABEL_MY_HEALTH = 'hdrMyHealth';
export const LABEL_MY_HEALTH_SUMMARY = 'hdrMyHealthSummary';
export const LABEL_OPT_OUT = 'lblOptOut';
export const LABEL_PROF_SETTING = 'lblProfSetting';
export const LABEL_NEED_HELP = 'lblNeedHelp';
export const LABEL_MY_PROVIDER = 'hdrMyProvider';
export const LABEL_MY_FAVORITE = 'hdrMyFavorites';
export const LABEL_LANGUAGE = 'hdrLanguageHeading';
export const LABEL_SELECT_CARD = 'hdrDigCardHeadingSelectCard';
export const LABEL_SHARE_CARD = 'hdrShareCardHeading';
export const LABEL_ROTATE_CARD = 'hdrFlipCardHeading';
export const LABEL_MESSAGE_PREVIEW = 'hdrBroadCastMessage';
export const LABEL_MESSAGE = 'hdrAlerts';
export const LABEL_UPLOAD_FILE = 'hdrUploadFile';
export const LABEL_UPLOAD = 'lblUploads';
export const LABEL_DIGITAL_CARD_DIG_CARD_MEMBER = 'hdrDigCardMember';
export const LABEL_DIGITAL_CARD_REFRESH = 'lblDigitalCardRefresh';
export const LABEL_DIGITAL_CARD_FAMILY_MEMBER_CARD = 'lblFamilyMemberCard';
export const LABEL_DIGITAL_CARD_MY_CARD = 'lblMyCard';
export const LABEL_DIGITAL_CARD_DIG_CARD_LAST_STORED = 'cntDigCardLastStored';
export const LABEL_DIGITAL_CARD_START_DATE = 'lblStartDate';
export const LABEL_DIGITAL_CARD_END_DATE = 'lblEndDate';
export const LABEL_DIGITAL_CARD_NOT_VALID = 'lblCardNotValid';
export const LABEL_MESSAGE_NO_ALERT = 'lblNoAlert';
export const LABEL_MESSAGE_NO_NEW_ALERT = 'lblNoNewAlert';
export const LABEL_MESSAGE_NEW_ALERT = 'lblNewAlerts';
export const LABEL_NO_INTERNET = 'hdgNoInternetHeading';
export const LABEL_NO_INTERNET_2 = 'hdgNoInternetHeading2';
export const LABEL_MY_BENEFITS_CASE_NUMBER = 'lblProgramCaseNumber';
export const LABEL_MY_BENEFITS_STATUS = 'lblStatus';
export const LABEL_MY_BENEFITS_ID = 'lblID';
export const LABEL_MY_BENEFITS_PROGRAM = 'lblProgram';
export const LABEL_MY_BENEFITS_START_DATE = 'lblStartDate';
export const LABEL_MY_BENEFITS_END_DATE = 'lblEndDate';
export const LABEL_SESSION_TIME_OUT = 'errorSessionTimeout';
export const LABEL_APP_TITLE = 'AppTitle';
export const LABEL_HELLO = 'lblHello';
export const LABEL_OPT_OUT_ALERT_TITLE = 'lblOptOutAlertTitle';
export const LABEL_OPT_OUT_CANCEL = 'lblCancel';
export const LABEL_OPT_OUT_SUBMIT = 'lblSubmit';
export const LABEL_OPT_OUT_SUCCESS_MSG = 'lblOptOutSuccessMsg';
export const LABEL_OPT_OUT_MSG = 'lblOptOutMsg';
export const LABEL_AFTER_OPT_OUT_MSG = 'lblAfterOptOutMsg';
export const LABEL_EXIT_HEAD = 'lblExitHead';
export const LABEL_EXIT_TEXT = 'lblExitText';
export const LABEL_YES = 'lblYes';
export const LABEL_NO = 'lblNo';
export const LABEL_OK = 'lblOk';
export const LABEL_PERMISSION_UNDETERMINED = 'undetermined';
export const LABEL_PERMISSION_AUTHORIZED = 'authorized';
export const LABEL_CALENDAR_SAVE_EVENT = 'lblCalendarSave';
export const LABEL_CALENDAR_PERMISSION_ERROR = 'lblCalendarError';
export const LABEL_CALENDAR_SAVE_EVENT_ERROR = 'lblCalendarSaveEventError';
export const LABEL_PERMISSION_CALENDAR_TEXT = 'lblPermissionCalendar';
export const LABEL_APPOINTMENT = 'lblAppointment';
export const LABEL_REGISTER_DOB = 'lblRegisterDob';
export const LABEL_GENERATE_CARD = 'lblGenerateCard';
export const LABEL_SHARE_CARD_SEND_EMAIL = 'hdrShareCardSendEmail';
export const LABEL_LOADING = 'lblLoading';
export const LABEL_DIG_CARD_FAMILY_MEMBER = 'hdrDigCardFamilyMember';
export const LABEL_TIMETRAKER_SUMMARY_COUNT = 'lblTimeTrackerSummary';
export const LABEL_HOURS = 'lblHours';
export const LABEL_PERMISSION_SENDTOAGENCY = 'lblPermission';
export const LABEL_SENDTOAGENCY_PARA = 'lblSendToAgencyPara';
export const LABEL_FILE_UPLOADING = 'lblFileUploading';
export const LABEL_UPLOAD_SUB_HEADER = 'lblUploadSubHeader';
export const LABEL_FILE_UPLOAD_SUCCESSFULLY = 'lblFileUploadedSuccessfully';
export const LABEL_DELETE_EXTRA_FILE_ONE = 'lblDeleteExtraFile1';
export const LABEL_DELETE_EXTRA_FILE_TWO = 'lblDeleteExtraFile2';
export const LABEL_NOT_VALID_FILE_FORMAT = 'lblNotValidFileFormate';
export const LABEL_FILE_SIZE_EXCEEDS = 'lblFileSizeExceeds';
export const LABEL_PARTIAL_UPLOAD = 'lblPartialUpload';
export const LABEL_COMMENT_REJECT = 'lblCommentReject';
export const LABEL_ADD_MORE = 'lblAddMore';
export const LABEL_SEND = 'lblSend';
export const LABEL_ERR_NO_RESPONSE = 'errNoResponse';
export const LABEL_HDR_NEED_HELP = 'hdrNeedHelp';
export const LABEL_FORMULARY = 'hdrFormulary';
export const LABEL_YOU = 'lblyou';
export const LABEL_SUPPORT = 'lblSupport';
export const LABEL_LOADING_CHAT = 'loading';
export const LABEL_ME = 'me';
export const LABEL_ERROR = 'error';
export const LABEL_CHATBOT = 'chatBot';
export const LABEL_SECOND = 'second';
export const LABEL_CAMERA = 'lblCamera';
export const LABEL_IMAGE_GALLERY = 'lblImageGallery';
export const LABEL_PDF_DOCUMENT = 'lblPdfDocument';
export const LABEL_CANCEL = 'lblCancel';
export const LABEL_VALIDATE = 'lblValidate';
export const LABEL_SUBMIT = 'lblSubmit';
export const LABEL_RESET = 'lblReset';
export const LABEL_CLEAR = 'lblClear';
export const LABEL_DISCARD = 'lblDiscard';
export const LABEL_LANGUAGE_SUBMIT = 'lblLangSubmit';
export const LABEL_LOGOUT = 'lblLogout';
export const LABEL_LANGUAGE_SUB_HEADING = 'hdrLanguageSubHeading';
export const LABEL_URL_NOT_SUPPORTED = 'errURLNotSupported';
export const LABEL_NOT_VALID_LINK = 'lblNotValidLink';
export const LABEL_NOT_VALID_PDF_LINK = 'lblNotValidPDFLink';
export const LABEL_DATE = 'lblDate';
export const LABEL_EXPIRES = 'lblExpires';
export const LABLE_ASK_QUESTION_PLACE_HOLDER = 'lblAskQuestionPlaceholder';
export const LABEL_NOT_OPEN_DATE_PICKER = 'lblNotOpenDatePicker';
export const LABEL_INVALID_CREDENTIALS = 'Invalid_Credentials';
export const LABEL_FIND_PROVIDER = 'hdrFindProvider';
export const LABEL_BROADCASTE_DATE = 'lblBroadcastDate';
export const LABEL_APPROVE = 'lblApprove';
export const LABEL_REJECT = 'lblReject';
export const LABEL_APPROVED = 'lblApproved';
export const LABEL_REJECTED = 'lblRejected';
export const LABEL_BROADCAST_SEND = 'lblBroadCastSend';
export const LABEL_BROADCAST_FAILURE = 'lblBroadcastFailure';
export const LABEL_SHARE_CARD_INFORM = 'hdrShareCardInform';
export const LABEL_SHARE_CARD_HEAD_TEXT = 'hdrShareCardHeadText';
export const LABEL_SHARE_CARD_HEAD_OTP_TEXT = 'hdrShareCardHeadOTPText';
export const LABEL_SHARE_CARD_MEMBER_ID = 'hdrShareCardMemID';
export const LABEL_SHARE_CARD_OTP = 'hdrShareCardOTP';
export const LABEL_SHARE_CARD_OTP_EXPIRY = 'hdrShareCardOTPExpiry';
export const LABEL_SHARE_CARD_TEXT = 'hdrShareCardText';
export const LABEL_PROVIDER_OTP = 'lblProviderOTP';
export const LABEL_USER_COMMENT = 'lblUserComment';
export const LABEL_ERR_FAVORITE_LIMIT = 'errFavoriteLimit';
export const LABEL_NO_PROVIDER_SEARCH_RESULTS = 'lblNoProvidersSearchResults';
export const LABEL_PROVIDER_SEARCH_RESULTS = 'lblProvidersSearchResults';
export const LABEL_OPEN_MAP = 'lblOpenInMap';
export const LABEL_MEMBER_INACTIVE = 'lblMemberInactive';
export const LABEL_LOCATION = 'lblLocation';
export const LABEL_DISTANCE = 'lblDistance';
export const LABEL_PROVIDER_TYPE = 'lblProviderType';
export const LABEL_PROVIDER_SPECIALTY = 'lblSpecialty';
export const LABEL_PROVIDER_NAME = 'lblProviderName';
export const LABEL_SEARCH_PROVIDER = 'lblSearchProvider';
export const LABEL_PROVIDER_SERCH_PCP_TITLE = 'lblPcpTitle';
export const LABEL_PROVIDER_SEARCH_NO_PCP_MESSAGE = 'lblNoPcp';
export const LABEL_PROVIDER_SEARCH_CHOOSE_PCP = 'lblChoosePcp';
export const LABEL_PROVIDER_SEARCH_SELECTED_PCP = 'lblPcpSelected';
export const LABEL_BUSINESS_NAME = 'lblBusinessName';
export const LABEL_BUSINESS_ADDRESS = 'lblBusinessAddress';
export const LABEL_BUSINESS_CITY = 'lblBusinessCity';
export const LABEL_BUSINESS_STATE = 'lblBusinessState';
export const LABEL_BUSINESS_ZIP = 'lblZip';
export const LABEL_NO_FAVOURITE = 'lblNoFavorite';
export const LABEL_FAVOURITE_RESULTS = 'lblFavoriteResults';
export const LABEL_REGISTER_FIRST_NAME = 'lblRegisterFirNam';
export const LABEL_REGISTER_LAST_NAME = 'lblRegisterLasNam';
export const LABEL_MEMBER_ID = 'lblMemberID';
export const LABEL_OR = 'lblOR';
export const LABEL_REGISTER_SSNO = 'lblRegisterSSNo';
export const LABEL_MEDICAID_ID = 'lblMedicadId';
export const LABEL_MEDICAID_ID_STATUS_NOT_VALID = 'lblMedicaidIDStatusNotValid';
export const LABEL_REGISTER_NEXT = 'lblRegisterNext';
export const LABEL_LOGIN_USER_NAME = 'lblLoginUsrNam';
export const LABEL_REGISTER_OPT_TFA = 'lblRegisterOptTFA';
export const LABEL_REGISTER_CONFIRM_USER_NAME = 'lblRegisterConUsrNam';
export const LABEL_REGISTER_MOBILE_NUMBER = 'lblRegisterMobileNo';
export const LABEL_EMAIL = 'lblEmail';
export const LABEL_LOGIN_PASSWORD = 'lblLoginPas';
export const LABEL_REGISTER_COUNT_PASSWORD_HINT = 'cntRegisterPasswordHint';
export const LABEL_REGISTER_COUNT_PASS = 'lblRegisterConPass';
export const LABEL_TERMS_AGREE = 'lblTermsAgree';
export const LABEL_TERMS_CONDITION = 'lblTermsCondition';
export const LABEL_WEEKDAY_ONE = 'weekDay1';
export const LABEL_WEEKDAY_TWO = 'weekDay2';
export const LABEL_WEEKDAY_THREE = 'weekDay3';
export const LABEL_WEEKDAY_FOUR = 'weekDay4';
export const LABEL_WEEKDAY_FIVE = 'weekDay5';
export const LABEL_WEEKDAY_SIX = 'weekDay6';
export const LABEL_WEEKDAY_SEVEN = 'weekDay7';
export const LABEL_REGISTER_HEADING_PAGE_2 = 'hdrRegisterHeadingPage2';
export const LABEL_ERR_PIN_MISS_MATCH = 'errValPinMisMatError';
export const LABEL_VAL_PIN_HEAD_ONE = 'hdrValPinHead1';
export const LABEL_PIN_HEADING = 'hdrPinHeading';
export const LABEL_VERIFY_MFA = 'hdrVerifyMFA';
export const LABEL_SETUP_MFA = 'hdrSetupMFA';
export const LABEL_SKIP = 'lblSkip';
export const LABEL_FINGERPRINT = 'lblFingerPrint';
export const LABEL_PIN_HEADING_ONLY_PIN = 'hdrPinHeadingPinOnly';
export const LABEL_PIN_HEADING_BIOMETRICS = 'hdrPinHeadingFingerPrint';
export const LABEL_PIN_HEAD_ONE = 'hdrPinHead1';
export const LABEL_PIN_RE_ENTER = 'lblPinReEnt';
export const LABEL_SEND_OTP = 'lblSendOTP';
export const LABEL_OTP_SENT_TEXT1 = 'lblOTPSendText1';
export const LABEL_OTP_SENT_TEXT2 = 'lblOTPSendText2';
export const LABEL_BTN_SEND_OTP = 'lblBtnOTPSend';
export const LABEL_BTN_RE_SEND = 'lblBtnResendCode';
export const LABEL_VERIFY_TEXT = 'lblVerifyCodeText';
export const LABEL_LOGIN_REGISTER = 'lblLoginReg';
export const LABEL_REGISTER_HEADING = 'hdrRegisterHeading';
export const LABEL_ADD_BUSINESS_VALUE = 'AddBusiness';
export const LABEL_BUSINESS_DETAILS = 'hdrBusinessDetails';
export const LABEL_COMMENT_APPROVE = 'lblCommentApprove';
export const LABEL_ERR_REG_MESSAGE_ADMIN_MAX_REQ = 'errRegisMessageAdminMaxReq';
export const LABEL_MODULE_ID = 'lblModuleId';
export const LABEL_TIME_TRACKER_ID = 'lblTimeTrackerID';
export const LABEL_UPLOAD_DOC_CURRENT_WEEk = 'lblUploadDocCurrentWeek';
export const LABEL_ADD_DETAILS = 'lblAddDetails';
export const LABEL_CURRENT_ADD = 'lblCurrentAdd';
export const LABEL_MODIFY_ADD = 'lblModifyAdd';
export const LABEL_ADDRESS1 = 'lblAddress1';
export const LABEL_ADDRESS2 = 'lblAddress2';
export const LABEL_CITY = 'lblCity';
export const LABEL_STATE = 'lbState';
export const LABEL_ZIP = 'lblZip';
export const LABEL_BACK = 'lblBack';
export const LABEL_AGE = 'lblAge';
export const LABEL_YEAR = 'lblYear';
export const LABEL_MONTHS = 'lblMonths';
export const LABEL_GENDER = 'lblGender';
export const LABEL_NEW_PIN = 'lblValPinReset';
export const LABEL_PIN_RESET = 'lblResetPIN';
export const LABEL_PIN_RESET_SUCCESSFUL = 'lblPinResetSuccess';
export const LABEL_CLOSE = 'lblClose';
export const LABEL_CLOSE_APP = 'lblCloseApp';
export const LABEL_OPTED_OUT = 'lblOptedOut';
export const LABEL_EN = 'en';
export const LABEL_PROVIDER_DATE = 'lblProviderDate';
export const LABEL_PROVIDER_IP = 'lblProviderIp';
export const LABEL_PROVIDER_EMAIL = 'lblProviderEmail';
export const LABEL_PRINT = 'lblPrint';
export const LABEL_REGIS_MOBILE_REQ = 'errRegisMobileReq';
export const LABEL_ERROR_REGIS_MOBILE_VALID = 'errRegisMobileValid';
export const LABEL_PHONE_NO_CHANGE = 'errNoChangeInPhone';
export const LABEL_SECURE_CODE_SENT_TO_REGMOBILE = 'lblSecureCodeSentToRegMob';
export const LABEL_SECURE_CODE_SENT_TO_REGEMAIL = 'lblSecureCodeSentToRegEmail';
export const LABEL_SECURE_CODE_SENT_SUCCESSFULLY = 'lblSecureCodeSentSuccessfully';
export const LABEL_EMAIL_REQ = 'errValEmailReq';
export const LABEL_EMAIL_VALID = 'errValidEmail';
export const LABEL_EMAIL_NO_CHANGE = 'errNoChangeInEmail';
export const LABEL_EMAIL_MIN_LENGTH = 'errValEmailminlength';
export const LABEL_EMAIL_MAX_LENGTH = 'errValEmailmaxlength';
export const LABEL_EMAIL_TIMER = 'lblEmailTimer';
export const LABEL_MOBILE_TIMER = 'lblMobileTimer';
export const BUTTON_MFA_STOP = 'lblBtnMFAStop';
export const LABEL_STOP_MFA = 'lblStopMFA';
export const LABEL_SELECT_TIME_FRAME = 'lblSelectTimeFrame';
export const LABEL_CLAIMS = 'lblClaims';
export const LABEL_PROCEDURES = 'lblProcedures';
export const LABEL_PROCEDURE_NAME = 'lblProcedureName';
export const LABEL_IMMUNIZATION = 'lblImmunizations';
export const LABEL_PRESCRIPTIONS = 'lblPrescriptions';
export const LABEL_PROVIDER_SEEN = 'lblProvidersSeen';
export const LABEL_PROVIDER = 'lblProvider';
export const LABEL_CLAIM_NO = 'lblClaimNo';
export const LABEL_NAME = 'lblName';
export const LABEL_PRO_CODE = 'lblProCode';
export const LABEL_DRUG_NAME = 'lblDrugName';
export const LABEL_DOSAGE = 'lblDosage';
export const LABEL_STATUS = 'lblStatus';
export const LABEL_PHONE = 'lblPhone';
export const LABEL_VIEW = 'lblView';
export const LABEL_SOMETHING_WENT_WRONG = 'lblSomethingWentWrong';
export const LABEL_EMAIL_IS_DEACTIVATED = 'lblEmailIsDeactivated';
export const LABEL_PHONE_IS_DEACTIVATED = 'lblPhoneIsDeactivated';

export const LABEL_MFA_SETUP_COMPLETE = 'lblMfaSetupCompleted';
export const LABEL_ACTIVATE_PHONE = 'lblActivatePhone';
export const LABEL_ACTIVATE_EMAIL = 'lblActivateEmail';
export const LABEL_CONFIRM_STOP_MFA = 'lblConfirmStopMFA';
export const LABEL_CONFIRM_STOP_PHONE = 'lblStopPhone';
export const LABEL_CONFIRM_STOP_EMAIL = 'lblStopEmail';
export const LABEL_CONFIRM_START_PHONE = 'lblStartPhone';
export const LABEL_CONFIRM_START_EMAIL = 'lblStartEmail';
export const LABEL_MOBILE_EMAIL_TIMER = 'lblEmailMobileTimer';
export const LABEL_OPTED_OUT_MFA = 'lblOptedOutMFA';
export const LABEL_MFA_CONTROLLER_INFO = 'lblMFAControllerInfo';
export const BUTTON_CONTINUE_MFA = 'lblBtnMFAComplete';
export const BUTTON_GO_TO_HOME = 'lblBtnGoToHome';
export const ERROR_DATE_MISMATCH = 'errDateMisMatch';
export const LABEL_DATA_DOWNLOADED_ON = 'lblDataDownloaded';
export const LABEL_DATA_LAST_DOWNLOADED = 'lblDataDownload';
export const LABEL_DOWNLOAD = 'lblDownload';
export const LABEL_MEDICAL_CONDITIONS = 'lblMedicalConditions';
export const LABEL_DRUG_CLASS = 'lblDrugClass';
export const LABEL_SEARCH_DRUG = 'lblSearchDrug';
export const LABEL_SELECT_DRUG_TYPES = 'lblDrugTypes';
export const LABEL_USED = 'lblUsed';
export const LABEL_DRUG_LIST = 'lblDrugList';
export const LABEL_DRUG_SEARCH_RESULTS = 'lblDrugSearchResults';
export const LABEL_BROWSER_PERMISSION = 'lblBrowserPermission';
export const LABEL_VERSION_NUMBER = 'lblVersionNumber';

export const KEY_ADDRESS1 = 'Address1';
export const KEY_ADDRESS2 = 'Address2';
export const KEY_CITY = 'City';
export const KEY_STATE = 'State';
export const KEY_ZIP = 'Zip';
export const NEXT = 'next';
export const ADDRESS_UPDATE_FORM = 'addressUpdateForm';
export const LABEL_NO_CURRENT_ADDRESS = 'errNoCurrentAddress';
export const SCREEN_FILE_NAME = 'ProfSetting.js';
export const GET_TOKEN_FUNCTION = 'getToken';
export const NO_RECORD_FOUND = 'No_Record_Found';
export const LABEL_ADDRESS_UPDATE_SUCCESS = 'addressUpdateSuccess';
export const EMPTY_VALUE = '';
export const ERROR_PIN_MISMATCH = 'errPinMisMat';
export const ERROR_ENTERD_SAME_PIN = 'errEnterSamePin';
export const DRAWER_LOCKED_CLOSED = 'locked-closed';
export const LABEL_DUPLICATE_BUSINESS = 'errDuplicateBusiness';
export const DUPLICATE_BUSINESS_ERROR_MESSAGE = 'BusinessName must be unique';
export const DUPLICATE_BUSINESS_NAME = '<BUSINESS_NAME>';
export const LANGUAGE_UPDATED_SUCCESS_MESSAGE = 'LocaleUpdateSuccess';
export const MODAL = 'modal';
export const ERR_SERVER_INTERNAL_ERROR = 'errServerInternalError';
export const FAVOURITE_RESULTS_FILE = 'FavouriteResults.js';
export const PROVIDER_RESULTS_FILE = 'ProviderResults.js';
export const STORAGE = 'storage';
export const USER = 'user';
export const USER_LOGIN = 'login';
export const NULL = 'null';
export const IE = 'IE';
export const CHROME = 'Chrome';
export const OPERA = 'Opera';
export const SAFARI = 'Safari';
export const SCREENS = 'screens';
export const REGISTER_FIRST = 'RegisterFirst';
export const LOCKED_OUT = 'Locked_Out';
export const PROVIDER_SIGN_IN = 'providerSignIn';
export const SCROLL_AMOUNT = '3';
export const ZIP_CODE = '<ZIPCODE>';
export const UNDERSCORE_BLANK = '_blank';
export const STATUS_I = 'I';
export const TELEPHONE = 'tel';
export const POSTAL_CODE = 'postal_code';
export const TIME_OUT = 10000;
export const MAXIMUM_AGE = 1000;
export const THREE_SEC_TIME_OUT = 30000;
export const SIXTY = 60;
export const SIXTY_FIVE = 65;
export const SEVENTY = 70;
export const EIGHTY = 80;
export const ONE_SIXTY_FIVE = 165;
export const TEXT = 'text';
export const DATE = 'date';
export const TWENTY_HOUR_HOUR = '24 Hr';
export const PROGRESS_SIZE = 24;
export const MOBILE = 'Mobile';
export const MOBILE_APP = 'M';
export const WEB_APP = 'W';
export const L = 'L';
export const LL = 'll';
export const LLL = 'LLL';
export const LT = 'LT';
export const L_LT = 'L LT';
export const DDD = 'ddd';
export const DDD_MMM_DO = 'ddd, MMM Do';
export const MMM_DD = 'MMM,DD';
export const TIME_TRACKER_DATE = 'timeTrackerDate';
export const ISO_WEEK = 'isoWeek';
export const DAYS = 'days';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const TIME_TRACKER_ID = 'TimeTrackerID';
export const MODULE_ID = 'SendToAgencyID';
export const TIME_TRACKER_NAME = 'TimeTracker';
export const MODULE_NAME = 'SendToAgency';
export const MODULE_TIME_TRACKER = 'TimeTracker';
export const LOGIN_TIME_OUT = 'timeout';
export const TRUE = 'true';
export const FALSE = 'false';
export const POP_STATE = 'popstate';
export const DAY = 'day';
export const ADD_BUSINESS = 'addBusiness';
export const A = 'A';
export const R = 'R';
export const S = 'S';
export const UNKNOWN = 'unknown';
export const fCM_TOKEN = 'fcmToken';
export const GET_TOKEN = 'getToken';
export const COMMON_MODULES = 'commonModules.js';
export const ERROR_TEXT = 'ErrorText';
export const PADDING = 'padding';
export const ALWAYS = 'always';
export const NEVER = 'never';
export const ABOUT_BLANCK = 'about:blank';
export const WINDOW = 'window';
export const ANIMATION_TYPE_FADE = 'fade';
export const BACK_SPACE = 'Backspace';
export const ASTERISK = '*';
export const TRANSPARENT = 'transparent';
export const NUMERIC = 'numeric';
export const COLON = ':';
export const CANCEL_STYLE = 'cancel';
export const OTP_NOT_MATCHED = 'Otp Not Matched!';
export const MINUTES = 'minutes';
export const HARDWARE_BACKPRESS = 'hardwareBackPress';
export const RADIO_VALUE = 'radioValue';
export const LAST_OTP_VALID = 'lastOTPValid';
export const KEYBOARD_EMAIL = 'email-address';
export const KEYBOARD_PHONE = 'phone-pad';
export const OPT_OUT_I = 'I';
export const OPT_OUT_O = 'O';
export const OPT_IN_MESSAGE_KEY = 'OPT_IN_MESSAGE_KEY';
export const FIREBASE_WEB_TOKEN = 'tokenWeb';
export const CHANNEL_ID = 'channelId';
export const CHANNEL_NAME = 'ChannelName';
export const CHANNEL_DESCRIPTION = 'Description of the channel';
export const DEFAULT_SOUND = 'default';
export const APP_ICON = 'icon';
export const WEBVIEW = 'WEBVIEW';
export const HANDLE_VIEW = 'HandleWebView';
export const LABEL_HTTP = 'http';
export const URL = 'url';
export const LABEL = 'label';
export const LABEL_EXTERNAL_LINKS = 'lblExternalLinks';
export const PAGE_HEADER_DIGITAL_CARD = 'hrdDigitalCard';
export const PAGE_HEADER_HEALTH_SUMMARY = 'hrdHealthSummary';
export const LABEL_POPUP_HEADER1 = 'lblPopupHeader1';
export const LABEL_POPUP_HEADER2 = 'lblPopupHeader2';
export const LABEL_POPUP_HEALTH_SUMMARY_HEADER1 = 'lblPopupHealthSummaryHeader1';
export const LABEL_POPUP_HEALTH_SUMMARY_HEADER2 = 'lblPopupHealthSummaryHeader2';
export const LABEL_VIEW_SHARED_CARD = 'lblViewSharedCard';
export const LABEL_VIEW_HEALTH_SUMMARY = 'lblViewHealthSummary';
export const INVALID_DATE = 'Invalid Date';
export const APP_NAME = '<AppName>';
export const ACCESSIBILITY_ENABLED = 'lblAccessibilityEnabled';
export const LOAD_LANGUAGES = 'LOAD_LANGUAGES';
export const LOAD_LANGUAGES_SUCCESS = 'LOAD_LANGUAGES_SUCCESS';
export const LOAD_LANGUAGES_FAIL = 'LOAD_LANGUAGES_FAIL';
